module.exports = {
  "country": "IE",
  "artist": "Marc Roberts",
  "song": "Mysterious Woman",
  "year": "1997",
  "place": "2",
  "spotify": "4ttOUTe2PEiaACM5DjDWYx"
};